import IResolvedPricing from "../contracts/IResolvedPricing";
import IStandardPricing from "../contracts/IStandardPricing";
import PricingHandler from "../contracts/PricingHandler";

/**
 * Assigns price to p1.
 *
 * @param input
 * @param resolvedPricing
 */
const standardHandler: PricingHandler<IStandardPricing> = (
  input,
  resolvedPricing,
): IResolvedPricing => ({
  ...resolvedPricing,
  price: input.p1,
  unitOfMeasure: input.unitOfMeasure,
});

export default standardHandler;
